import dayJs from 'dayjs';
import { ElMessageBox } from "element-plus";
import router from '@/router'

const resultMsg = {
	result: false,
	message: ''
}

/* 合法uri*/
export function validateURL(textval: string) {
	const urlregex = /^(http|ftp|https):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
	return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str: string) {
	const reg = /^[a-z]+$/
	return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str: string) {
	const reg = /^[A-Z]+$/
	return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str: string) {
	const reg = /^[A-Za-z]+$/
	return reg.test(str)
}

/*判断输入的EMAIL格式是否正确 */
export function validateIsEmail(str: string) {
	if (str.length != 0) {
		const reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
		return reg.test(str);
	}
}

export function validateIsPassword(str: string) {
	str += '';
	// 密码要求6-16位，至少包含数字、字母、符号两种元素
	let pPattern = /((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*.,\/\\|:;"'<>?])|(?=.*\d)(?=.*[#@!~%^&*.,\/\\|:;"'<>?]))[a-z\d#@!~%^&*.,\/\\|:;"'<>?]{6,16}/i;
	return pPattern.test(str);
}

/*判断输入的手机号格式是否正确 */
export function validateIsPhone(str: string) {
	if (str.length != 0) {
		const reg = /^1(3[0-9]|4[57]|5[012356789]|6[2567]|7[0178]|8[0-9]|9[189])\d{8}$/;
		return reg.test(str);
	}
}


/*验证正整数*/
export function validateNum(value: string) {
	const reg = /^[1-9][0-9]*$/;
	return reg.test(value);
}

//校验输入非中文  true 是中文
export function noChinese(value: string) {
	const reg = /[\u4e00-\u9fa5]/;
	return reg.test(value);
}


//校验输入是否是数字（包括正负、小数点）
export function inputOrNumber(value: string) {
	const reg = /[-+]*[0-9][.][0-9]+|[-+]*[1-9][0-9]*|^[0]$/;
	return reg.test(value);
}

//获取URL参数
export function getQueryVariable(variable: string) {
	const w = location.hash.indexOf('?');
	const query = location.hash.substring(w + 1);

	const vars = query.split('&');
	for (let i = 0; i < vars.length; i++) {
		const pair = vars[i].split('=');
		if (pair[0] == variable) { return pair[1]; }
	}
	return false
}

//数组元素互换位置
export function swapArray(arr: Array<any>, index1: number, index2: number) {
	arr[index1] = arr.splice(index2, 1, arr[index1])[0];
	return arr;
}
export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

// 格式化数字（每三位加逗号）
export function toThousands(num: string) {
	const numSplit = num.split('.');
	let start = numSplit[0] || num;
	const end = numSplit[2] || '';
	let before = [];
	while (start.length > 3) {
		before.push(start.substring(start.length - 3));
		start = start.substring(0, start.length - 3);
	}
	if (start) {
		before.push(start);
	}
	start = before.reverse().join();
	if (end) {
		return start + '.' + end;
	}
	return start;
}

// 判断移动端
export function isMobile() {
	return navigator.userAgent.includes('Mobile');
}

/**
 * 判断是深色
 * @param hex { string } 需要判断的颜色 列子：#ffffff
 * @return { boolean } true 背景是深色、false背景是浅色 hex错误返回false
 */
export function inDark(hex: string) {
	if (hex.length === 7 && /^#\d{6}$/) {
		const RGB = [parseInt(hex[1] + hex[2], 16), parseInt(hex[3] + hex[4], 16), parseInt(hex[5] + hex[6], 16)];
		const grayScale: number = RGB[0] * 0.299 + RGB[1] * 0.587 + RGB[2] * 0.114;
		return grayScale < 192;
	}
	return false;
}
/**
 * @function transformTime 数字秒数转换时间格式
 * @param t
 * 数字
 */
export function transformTime(t: number) {
	if (t === 0) {
		return '00:00:00'
	} else {
		let s: any = Math.floor(t / 1) % 60
		t = Math.floor(t / 60)
		let i: any = t % 60
		t = Math.floor(t / 60)
		let h: any = t % 24
		s = s.toString().length === 1 ? `0${s}` : s
		i = i.toString().length === 1 ? `0${i}` : i
		h = h.toString().length === 1 ? `0${h}` : h
		return h + ':' + i + ':' + s
	}
};
//初始化学年年份选择器
export function getSemester() {
	const now: string = dayJs().format('YYYY')
	const arr = []
	for (let i = -1; i <= 1; i++) {
		arr.push({
			value: `${Number(now) + i}-${Number(now) + i + 1}`
		})
	}
	for (let i = -6; i <= -2; i++) {
		arr.push({
			value: `${Number(now) + i}-${Number(now) + i + 1}`
		})
	}
	return arr;
}

//判断机构无付费提示
export function isPayingUser() {
	ElMessageBox.confirm(`您的机构尚未付费，没有权限使用该功能。请联系商务进行开通！`, `系统提示`, {
		confirmButtonText: "去了解",
		cancelButtonText: "知道了",
		type: "warning",
	}).then(() => {
			router.push({path:"/AccountInfo/agencyInfo"})
	}).catch(() => {});
}

//获取入学学年
export function getEnrollLists() {
	const now: string = dayJs().format('YYYY')
	const arr = []
	for (let i =1; i>=-10; i--) {
		arr.push({
			value: `${Number(now) + i}`
		})
	}
	return arr;
}